import { computed, Injectable, signal } from '@angular/core';
import { CustomOrderEntry } from '@cart/const';

const INITIAL_SECONDS = 5;

@Injectable({
  providedIn: 'root',
})
export class CartUndoService {
  readonly initialSeconds = INITIAL_SECONDS;

  private currentUndoEntry = signal<CustomOrderEntry | null>(null);
  private seconds = signal(this.initialSeconds);
  private timer: ReturnType<typeof setTimeout> | null = null;
  private revertEntry = signal<CustomOrderEntry | null>(null);

  readonly secondsLeft = computed(() => this.seconds());
  readonly isUndoVisible = computed(() => this.currentUndoEntry() !== null);
  readonly revertEntryTriggered = computed(() => this.revertEntry());

  registerUndo(entry: CustomOrderEntry): void {
    this.clearTimer();
    this.currentUndoEntry.set(entry);
    this.seconds.set(this.initialSeconds);
    this.startTimer();
  }

  undo(): void {
    const entry = this.currentUndoEntry();

    if (entry) {
      this.clearTimer();
      this.revertEntry.set(entry);
      this.currentUndoEntry.set(null);
    }
  }

  clear(): void {
    this.clearTimer();
    this.revertEntry.set(null);
    this.currentUndoEntry.set(null);
  }

  private startTimer(): void {
    this.timer = setInterval(() => {
      const current = this.seconds();
      if (current <= 1) {
        this.clear();
      } else {
        this.seconds.set(current - 1);
      }
    }, 1000);
  }

  private clearTimer(): void {
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }
  }
}
